<template>
  <el-dialog
    title="录入线下协议/保单"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <div v-loading="loading">
      <el-form ref="agreementForm" :model="formData">
        <div v-for="(policy, index) in policyList" :key="index" class="policy-item" :style="index > 0 ? 'border-top: 1px solid #eee; padding-top: 20px;' : ''">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生效时间：" :rules="timeRules">
                <el-date-picker
                  v-model="policy.effectedAt"
                  type="date"
                  placeholder="请选择生效时间"
                  value-format="timestamp"
                  style="width: 100%"
                  :disabled="policy.disabled"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label="失效时间：" :rules="expiredTimeRules">
                <el-date-picker
                  v-model="policy.expiredAt"
                  type="date"
                  placeholder="请选择失效时间"
                  value-format="timestamp"
                  style="width: 100%"
                  :disabled="policy.disabled"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="大保单号：" :rules="policyNoRules">
            <el-input
              v-model="policy.policyNo"
              placeholder="请输入大保单号"
              :disabled="policy.disabled"
            ></el-input>
          </el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="协议文件：">
                <div v-if="policy.agreementFileList && policy.agreementFileList.length > 0">
                  <el-button size="small" @click="viewFile(policy.agreementFileList[0].url)">查看</el-button>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="(response, file, fileList) => handleAgreementUploadSuccess(response, file, fileList, index)"
                    :on-error="(err, file, fileList) => handleAgreementUploadError(err, file, fileList, index)"
                    :on-remove="(file, fileList) => handleAgreementUploadRemove(file, fileList, index)"
                    :file-list="policy.agreementFileList"
                    :limit="1"
                    :on-exceed="(files, fileList) => handleAgreementUploadExceed(files, fileList, index)"
                    :disabled="policy.disabled"
                    :data="{name: 'fileVal'}"
                    style="margin-left: 10px;"
                  >
                    <el-button size="small" type="primary" :disabled="policy.disabled">重新上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png/jpeg文件</div>
                  </el-upload>
                </div>
                <div v-else>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="(response, file, fileList) => handleAgreementUploadSuccess(response, file, fileList, index)"
                    :on-error="(err, file, fileList) => handleAgreementUploadError(err, file, fileList, index)"
                    :on-remove="(file, fileList) => handleAgreementUploadRemove(file, fileList, index)"
                    :file-list="policy.agreementFileList"
                    :limit="1"
                    :on-exceed="(files, fileList) => handleAgreementUploadExceed(files, fileList, index)"
                    :disabled="policy.disabled"
                    :data="{name: 'fileVal'}"
                  >
                    <el-button size="small" type="primary" :disabled="policy.disabled">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png/jpeg文件</div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
            
            <el-col :span="12">
              <el-form-item label="电子保单：">
                <div v-if="policy.policyFileList && policy.policyFileList.length > 0">
                  <el-button size="small" @click="viewFile(policy.policyFileList[0].url)">查看</el-button>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="(response, file, fileList) => handlePolicyUploadSuccess(response, file, fileList, index)"
                    :on-error="(err, file, fileList) => handlePolicyUploadError(err, file, fileList, index)"
                    :on-remove="(file, fileList) => handlePolicyUploadRemove(file, fileList, index)"
                    :file-list="policy.policyFileList"
                    :limit="1"
                    :on-exceed="(files, fileList) => handlePolicyUploadExceed(files, fileList, index)"
                    :disabled="policy.disabled"
                    :data="{name: 'fileVal'}"
                    style="margin-left: 10px;"
                  >
                    <el-button size="small" type="primary" :disabled="policy.disabled">重新上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png/jpeg文件</div>
                  </el-upload>
                </div>
                <div v-else>
                  <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="(response, file, fileList) => handlePolicyUploadSuccess(response, file, fileList, index)"
                    :on-error="(err, file, fileList) => handlePolicyUploadError(err, file, fileList, index)"
                    :on-remove="(file, fileList) => handlePolicyUploadRemove(file, fileList, index)"
                    :file-list="policy.policyFileList"
                    :limit="1"
                    :on-exceed="(files, fileList) => handlePolicyUploadExceed(files, fileList, index)"
                    :disabled="policy.disabled"
                    :data="{name: 'fileVal'}"
                  >
                    <el-button size="small" type="primary" :disabled="policy.disabled">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png/jpeg文件</div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="备注：">
            <el-input
              v-model="policy.note"
              type="textarea"
              placeholder="请输入备注"
              :rows="3"
              :disabled="policy.disabled"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="保单余额(元)：" v-if="policy.balance !== null && policy.balance !== undefined">
            <el-input
              v-model="policy.balance"
              disabled
            ></el-input>
          </el-form-item>
          
          <div style="text-align: right; margin-bottom: 20px;">
            <el-button 
              v-if="index === 0" 
              type="primary" 
              size="small" 
              @click="addPolicy"
            >
              添加续保
            </el-button>
            <el-button 
              v-if="index > 0" 
              type="danger" 
              size="small" 
              @click="removePolicy(index)"
            >
              删除
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveDhGxbUserPolicy, getDhGxbUserPolicyList } from '@/api/member'

export default {
  name: 'AgreementPolicy',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    // 生效时间和失效时间验证规则
    const validateEffectedAt = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择生效时间'))
      } else {
        // 检查是否早于失效时间（只比较日期部分）
        const fieldParts = rule.field.split('.');
        const policyIndex = parseInt(fieldParts[1]);
        const policy = this.policyList[policyIndex];
        if (policy && policy.expiredAt) {
          // 将两个日期都设置为当天的0点进行比较
          const effectDate = new Date(value);
          effectDate.setHours(0, 0, 0, 0);
          
          const expireDate = new Date(policy.expiredAt);
          expireDate.setHours(0, 0, 0, 0);
          
          if (effectDate.getTime() > expireDate.getTime()) {
            callback(new Error('生效时间必须早于或等于失效时间'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
    
    const validateExpiredAt = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择失效时间'))
      } else {
        // 检查是否晚于生效时间（只比较日期部分）
        const fieldParts = rule.field.split('.');
        const policyIndex = parseInt(fieldParts[1]);
        const policy = this.policyList[policyIndex];
        if (policy && policy.effectedAt) {
          // 将两个日期都设置为当天的0点进行比较
          const effectDate = new Date(policy.effectedAt);
          effectDate.setHours(0, 0, 0, 0);
          
          const expireDate = new Date(value);
          expireDate.setHours(0, 0, 0, 0);
          
          if (expireDate.getTime() < effectDate.getTime()) {
            callback(new Error('失效时间必须晚于或等于生效时间'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      formData: {}, // 用于el-form的model
      policyList: [{
        effectedAt: '',
        expiredAt: '',
        policyNo: '',
        note: '',
        balance: null,
        agreementFileList: [],
        policyFileList: [],
        disabled: false
      }],
      timeRules: [
        { required: true, validator: validateEffectedAt, trigger: 'change' }
      ],
      expiredTimeRules: [
        { required: true, validator: validateExpiredAt, trigger: 'change' }
      ],
      policyNoRules: [
        { required: true, message: '请输入大保单号', trigger: 'blur' }
      ],
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.resetForm()
        this.fetchPolicyList()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.resetForm()
    },
    
    handleSuccess() {
      this.$emit('success')
    },
    
    handleError() {
      // 空实现，防止控制台报错
    },
    
    resetForm() {
      // 重置表单验证
      if (this.$refs.agreementForm) {
        this.$refs.agreementForm.resetFields()
      }
      
      this.policyList = [{
        effectedAt: '',
        expiredAt: '',
        policyNo: '',
        note: '',
        balance: null,
        agreementFileList: [],
        policyFileList: [],
        disabled: false
      }]
    },
    
    // 添加续保
    addPolicy() {
      this.policyList.push({
        effectedAt: '',
        expiredAt: '',
        policyNo: '',
        note: '',
        balance: null,
        agreementFileList: [],
        policyFileList: [],
        disabled: false
      })
    },
    
    // 删除续保
    removePolicy(index) {
      this.policyList.splice(index, 1)
    },
    
    // 获取已有的保单信息
    async fetchPolicyList() {
      this.loading = true
      try {
        // 调用API获取用户已有的保单信息（与spbprod项目保持一致）
        const res = await getDhGxbUserPolicyList({ gxb_user_id: this.userId })
        console.log('API返回的保单数据:', res); // 调试信息
        if (res.err_code === 0 && res.rows && res.rows.length > 0) {
          // 处理返回的数据，转换为组件所需格式
          this.policyList = res.rows.map(item => {
            console.log('单个保单数据:', item); // 调试信息
            // 将分转换为元显示
            const balance = item.balance !== null && item.balance !== undefined ? (item.balance / 100).toFixed(2) : null;
            
            // 处理生效时间和失效时间（处理ISO格式的时间字符串）
            let effectedAt = '';
            let expiredAt = '';
            
            // 根据spbprod项目中的实现，使用effected_at和expired_at字段（API返回的是ISO格式时间字符串）
            if (item.effected_at && item.effected_at !== '0001-01-01T00:00:00Z' && item.effected_at !== '1970-01-01T00:00:00Z') {
              // 处理ISO格式时间字符串
              effectedAt = new Date(item.effected_at).getTime();
              console.log('生效时间转换:', item.effected_at, '->', effectedAt); // 调试信息
            }
            
            if (item.expired_at && item.expired_at !== '0001-01-01T00:00:00Z' && item.expired_at !== '1970-01-01T00:00:00Z') {
              // 处理ISO格式时间字符串
              expiredAt = new Date(item.expired_at).getTime();
              console.log('失效时间转换:', item.expired_at, '->', expiredAt); // 调试信息
            }
            
            console.log('处理后的时间:', { effectedAt, expiredAt }); // 调试信息
            
            return {
              effectedAt: effectedAt,
              expiredAt: expiredAt,
              policyNo: item.policy_no || '',
              note: item.note || '',
              balance: balance,
              agreementFileList: item.agreement_url ? [{ name: '协议文件', url: item.agreement_url }] : [],
              policyFileList: item.policy_url ? [{ name: '电子保单', url: item.policy_url }] : [],
              disabled: item.status === 2 // 如果状态为2（已过期），则禁用
            };
          });
        } else {
          // 如果没有数据，保持默认的第一个空保单
          this.policyList = [{
            effectedAt: '',
            expiredAt: '',
            policyNo: '',
            note: '',
            balance: null,
            agreementFileList: [],
            policyFileList: [],
            disabled: false
          }];
        }
      } catch (error) {
        console.error('获取保单信息失败:', error);
        this.$message.error('获取保单信息失败');
        // 出错时也保持默认的第一个空保单
        this.policyList = [{
          effectedAt: '',
          expiredAt: '',
          policyNo: '',
          note: '',
          balance: null,
          agreementFileList: [],
          policyFileList: [],
          disabled: false
        }];
      } finally {
        this.loading = false
      }
    },
    
    handleAgreementUploadSuccess(response, file, fileList, index) {
      this.$set(this.policyList[index], 'agreementFileList', fileList)
      this.$message.success('协议文件上传成功')
      this.handleSuccess() // 触发成功事件
    },
    
    handleAgreementUploadError(err, file, fileList, index) {
      this.$message.error('协议文件上传失败')
      this.handleError() // 触发错误事件
    },
    
    handleAgreementUploadRemove(file, fileList, index) {
      this.$set(this.policyList[index], 'agreementFileList', fileList)
    },
    
    handleAgreementUploadExceed(files, fileList, index) {
      this.$message.warning('只能上传一个协议文件')
    },
    
    handlePolicyUploadSuccess(response, file, fileList, index) {
      this.$set(this.policyList[index], 'policyFileList', fileList)
      this.$message.success('电子保单上传成功')
      this.handleSuccess() // 触发成功事件
    },
    
    handlePolicyUploadError(err, file, fileList, index) {
      this.$message.error('电子保单上传失败')
      this.handleError() // 触发错误事件
    },
    
    handlePolicyUploadRemove(file, fileList, index) {
      this.$set(this.policyList[index], 'policyFileList', fileList)
    },
    
    handlePolicyUploadExceed(files, fileList, index) {
      this.$message.warning('只能上传一个电子保单')
    },
    
    // 查看文件
    viewFile(url) {
      window.open(url, '_blank')
    },
    
    async handleSubmit() {
      // 验证所有表单
      let valid = true
      
      // 首先验证表单
      try {
        await this.$refs.agreementForm.validate()
      } catch (error) {
        valid = false
      }
      
      if (!valid) {
        this.$message.warning('请检查表单填写是否正确')
        return
      }
      
      // 额外验证文件上传
      for (let i = 0; i < this.policyList.length; i++) {
        const policy = this.policyList[i]
        
        // 检查文件是否已上传
        if (policy.agreementFileList.length === 0) {
          this.$message.warning('请上传协议文件')
          valid = false
          break
        }
        
        if (policy.policyFileList.length === 0) {
          this.$message.warning('请上传电子保单')
          valid = false
          break
        }
      }
      
      if (!valid) return
      
      this.submitting = true
      try {
        // 构造符合老项目接口要求的数据结构（与spbprod项目保持一致）
        const policyData = {
          gxb_user_id: Number(this.userId),
          policy_list: this.policyList.map(policy => {
            // 过滤掉已过期的保单（disabled为true的）
            if (policy.disabled) {
              return null
            }
            
            // 处理生效时间和失效时间（与spbprod项目保持一致）
            let effectDate = null
            let expireDate = null
            
            if (policy.effectedAt) {
              // 生效时间设置为当天的0点（与spbprod项目保持一致）
              const effectDateObj = new Date(policy.effectedAt)
              effectDateObj.setHours(0, 0, 0, 0)
              effectDate = Math.floor(effectDateObj.getTime() / 1000)
            }
            
            if (policy.expiredAt) {
              // 失效时间设置为当天的23:59:59（与spbprod项目保持一致）
              const expireDateObj = new Date(policy.expiredAt)
              expireDateObj.setHours(23, 59, 59, 999)
              expireDate = Math.floor(expireDateObj.getTime() / 1000)
            }
            
            // 处理保单余额（与spbprod项目保持一致）
            let balance = null;
            if (policy.balance !== null && policy.balance !== undefined) {
              // 将元转换为分（与spbprod项目保持一致）
              balance = Math.round(parseFloat(policy.balance) * 100);
            }
            
            return {
              policy_no: policy.policyNo,
              note: policy.note,
              effect_date: effectDate,
              expire_date: expireDate,
              agreement_url: (policy.agreementFileList[0].response && policy.agreementFileList[0].response.data) || policy.agreementFileList[0].url,
              policy_url: (policy.policyFileList[0].response && policy.policyFileList[0].response.data) || policy.policyFileList[0].url,
              balance: balance
            }
          }).filter(item => item !== null)
        }
        
        console.log('提交的数据:', policyData); // 调试信息
        
        const res = await saveDhGxbUserPolicy(policyData)
        if (res.err_code === 0) {
          this.$message.success('保存成功')
          this.handleSuccess() // 触发成功事件
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
          this.handleError() // 触发错误事件
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
        this.handleError() // 触发错误事件
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}

.upload-demo {
  width: 100%;
}

.policy-item {
  margin-bottom: 20px;
}
</style>